import { ScheduleRouteWeeklyDayIndex } from '~services/scheduleRoute/types';

import { ScheduleRouteRepetionDescriptionDayFormat } from './types';

export const DAY_NAME_FORMATS: Record<
  ScheduleRouteRepetionDescriptionDayFormat,
  Record<ScheduleRouteWeeklyDayIndex, string>
> = {
  short: {
    0: 'D',
    1: 'L',
    2: 'M',
    3: 'X',
    4: 'J',
    5: 'V',
    6: 'S',
  },
  long: {
    0: 'DO',
    1: 'LU',
    2: 'MA',
    3: 'MI',
    4: 'JU',
    5: 'VI',
    6: 'SA',
  },
};
